import {
  DatePipe,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HighchartsChartModule } from "highcharts-angular";
import { NgxWebstorageModule } from "ngx-webstorage";
import { AuthenticationGuard } from "./core/auth/guards/authentication-guard";
import { QualityGuard } from "./core/auth/guards/quality-guard";
import { DndModule } from "./ng2-dnd/dnd.module";
import { ChildRouteRedirectComponent } from "./shared-ui-refresh/child-route-redirect-component/child-route-redirect.component";

import { AuthorizationGuard } from "./core/auth/guards/authorization-guard";
import { AuthorizationService } from "./core/auth/guards/authorization.service";
import { LoginComponent } from "./core/auth/login/login.component";

import { headerHandlerService } from "./core/nav/header-handler.service";
import { NavigationHandlerService } from "./core/nav/navigation-handler.service";
import { SubheaderHandlerService } from "./core/nav/subheader-handler.service";

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslateModule, provideTranslateCompiler } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { LoggerService } from "./core/logger/global-logger.service";
import { LoggerComponent } from "./core/logger/logger.component";
// import { ToasterModule } from 'angular2-toaster';
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app.component";
import { APP_ROUTER } from "./app.routes";
// this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { NgIdleKeepaliveModule } from "./ng-idle-keepalive/ng-idle-keepalive.module";
// optional, provides moment-style pipes for date formatting
// import { MomentModule } from 'angular2-moment';
import { LocalCacheModule } from "./core/local-cache/local-cache.module";
import { LocalCacheService } from "./core/local-cache/local-cache.service";
import { SimpleTimer } from "./ng2-simple-timer/ng2-simple-timer.service";
// import { HttpInterctor } from './core/auth/http.interceptor';
import { MsalRedirectComponent } from "@azure/msal-angular";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import * as Highcharts from "highcharts";
import * as Histogram from "highcharts/modules/histogram-bellcurve";
import { TranslateMessageFormatCompiler } from "ngx-translate-messageformat-compiler";
import { PENDO_ACCOUNT_REPORTER } from "../libraries/Ecolab.UI.Library/projects/ui-library/src/lib/features/global-search-filters/services/pendo-account-reporter.token";
import { PendoAnalyticsService } from "./core/analytics/pendo-analytics.service";
import { AssetTreeGuard } from "./core/auth/guards/asset-tree-guard";
import { HttpErrorCatchingInterceptor } from "./core/auth/httpError.interceptor";
import { LogoutComponent } from "./core/auth/logout/logout.component";
import { MsalApplicationModule } from "./core/auth/msalv3-application.module";
import { RequestHeadersInterceptor } from "./core/auth/request-headers.interceptor";
import { SessionIdInterceptor } from "./core/auth/sessionId.interceptor";
import { ApplicationDowntimeComponent } from "./core/components/application-downtime/application-downtime.component";
import { HomeComponent } from "./core/components/home/home.component";
import { FilterNavigation } from "./core/pipes/filter-navigation.pipe";
import { AppConfigService } from "./core/services/app-config.service";
import { CompositeErrorHandlerService } from "./core/services/error-management/composite-error-handler.service";
import { MsalV3Service } from "./core/services/msal-V3.service";
import { UserService } from "./core/user/user.service";
import { ErrorHandlerComponent } from "./data-visualization/error-handler/error-handler.component";
import { MenuModule } from "./menu/menu.module";
import {
  IdleExpiry,
  LocalStorageExpiry,
  NgIdleModule,
} from "./ng-idle-core/public-api";
import { SharedMainModule } from "./shared-main/shared-main.module";
import { AppHeaderModule } from "./shared-ui-refresh/app-header/app-header.module";
import { UserProfileDetailsModule } from "./shared-ui-refresh/user-profile-details/user-profile-details.module";
import { ErrorhandlingPopupComponent } from "./shared/components/error-handling/errorhandling-popup/errorhandling-popup.component";
import { FnbComponent } from "./shared/components/fnb/fnb.component";
import { SiteService } from "./shared/services/site.service";
// Highcharts modules
import {
  ApmErrorHandler,
  ApmModule,
  ApmService,
} from "@elastic/apm-rum-angular";
import HighchartsMore from "highcharts/highcharts-more.src";
import HighchartsBoost from "highcharts/modules/boost.src";
import HighChartsExport from "highcharts/modules/exporting";
import HighChartsNoData from "highcharts/modules/no-data-to-display";
import HighchartsSankey from "highcharts/modules/sankey.src";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";
import { EVAAIAgentModule } from "../libraries/e3duiplatform-eva-mfe/libs/eva/src/lib/ai-agent/ai-agent.module";
import { ApplicationInsightsErrorHandler } from "./core/auth/appInsightsErrorHandler";
import { ConsentPageComponent } from "./core/components/consent-page/consent-page.component";
import { EvaChatbotComponent } from "./core/components/eva-chatbot/eva-chatbot.component";
import { ErrorPageModule } from "./core/fallback-modules/error-page/error-page.module";
import { SidePanelModule } from "./shared-ui-refresh/side-panel/side-panel.module";
import { TermsAndConditionsModule } from "./shared/e3d-modules/terms-and-conditions/terms-and-conditions.module";
import { HttpLoggingInterceptor } from "./shared/interceptors/http-logger-interceptor/http-logging.interceptor";

HighChartsNoData(Highcharts);
HighChartsExport(Highcharts);

// ***** section for all factories ******
// eslint-disable-next-line
// export function createTranslateLoader(http: HttpClient) {
//   const headers = new HttpHeaders();
//   headers.set(
//     'Cache-Control',
//     'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
//   );
//   headers.set('Pragma', 'no-cache');
//   headers.set('Expires', '0');
//   http.options('', { headers: headers });
//   return new TranslateHttpLoader(
//     http,
//     './assets/i18n/',
//     // eslint-disable-next-line
//     '.json?v=' + Date.now()
//   );
// }

// eslint-disable-next-line
export function HighchartsModules() {
  // apply Highstock Modules to this array
  return [
    HighchartsMore,
    HighchartsSankey,
    HighchartsBoost,
    Histogram,
    HighChartsNoData,
    HighchartsSolidGauge,
    HighChartsExport,
  ];
}
declare global {
  interface Navigator {
    // eslint-disable-next-line
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoggerComponent,
    HomeComponent,
    FilterNavigation,
    ApplicationDowntimeComponent,
    FnbComponent,
    ErrorHandlerComponent,
    ErrorhandlingPopupComponent,
    LogoutComponent,
    ConsentPageComponent,
    ChildRouteRedirectComponent,
  ],
  exports: [
    ErrorhandlingPopupComponent,
    ErrorHandlerComponent,
    ConsentPageComponent,
    ChildRouteRedirectComponent,
  ],
  // entryComponents: [ErrorHandlerComponent, ErrorhandlingPopupComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    MsalApplicationModule.forRoot(),
    ApmModule,
    // RouterModule.forRoot(APP_ROUTES, { preloadingStrategy: PreloadAllModules, useHash: true}),
    APP_ROUTER,
    SharedMainModule.forRoot(),
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json",
        enforceLoading: true,
        useHttpBackend: true,
      }),
      fallbackLang: "en",
      compiler: provideTranslateCompiler(TranslateMessageFormatCompiler),
    }),
    BrowserModule,
    BrowserAnimationsModule,
    DndModule.forRoot(),
    NgbModule,
    //    ToasterModule,
    ToastrModule.forRoot(), // ToastrModule added
    NgxWebstorageModule.forRoot({
      prefix: "nalco",
      separator: ".",
      caseSensitive: true,
    }),
    NgIdleModule.forRoot(),
    // MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    LocalCacheModule.forRoot({
      mode: "session",
      namespace: "ecolab.envision_",
    }),
    DropDownsModule,
    AppHeaderModule,
    MenuModule,
    UserProfileDetailsModule,
    ErrorPageModule,
    SidePanelModule,
    TermsAndConditionsModule,
    EvaChatbotComponent,
    EVAAIAgentModule
  ],
  providers: [
    ApplicationInsightsErrorHandler,
    ApmErrorHandler,
    ApmService,
    AppConfigService,
    DatePipe,
    SimpleTimer,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HighchartsChartModule, useFactory: HighchartsModules },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorCatchingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoggingInterceptor,
      multi: true,
    },
    {
      provide: IdleExpiry,
      useClass: LocalStorageExpiry,
    },
    AuthenticationGuard,
    QualityGuard,
    AssetTreeGuard,
    AuthorizationGuard,
    AuthorizationService,
    SubheaderHandlerService,
    headerHandlerService,
    NavigationHandlerService,
    LoggerService,
    LocalCacheService,
    UserService,
    MsalV3Service,
    SiteService,
    NgbActiveModal,
    {
      provide: ErrorHandler,
      useClass: CompositeErrorHandlerService,
    },
    FilterNavigation,
    // Lets the global search filters report the selected customer hierarchy as the Pendo account
    // without the library depending on the application. `useExisting` keeps the root singleton, so
    // every consumer shares the same account context.
    {
      provide: PENDO_ACCOUNT_REPORTER,
      useExisting: PendoAnalyticsService,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule { }
